import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon, ChevronUpIcon } from 'lucide-react';
interface ReadMoreProps {
  preview: React.ReactNode;
  children: React.ReactNode;
}
export function ReadMore({
  preview,
  children
}: ReadMoreProps) {
  const [isExpanded, setIsExpanded] = useState(false);
  return <div className="relative" data-id="element-169">
      <div className="text-lg text-charcoal-light leading-relaxed" data-id="element-170">
        {preview}
      </div>

      <AnimatePresence initial={false} data-id="element-171">
        {isExpanded && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3,
        ease: 'easeInOut'
      }} className="overflow-hidden" data-id="element-172">
            <div className="pt-4 text-lg text-charcoal-light leading-relaxed" data-id="element-173">
              {children}
            </div>
          </motion.div>}
      </AnimatePresence>

      <button onClick={() => setIsExpanded(!isExpanded)} className="mt-4 flex items-center gap-2 text-amber-600 font-medium hover:text-amber-700 transition-colors group" data-id="element-174">
        {isExpanded ? 'Leer menos' : 'Leer más'}
        <motion.div animate={{
        rotate: isExpanded ? 180 : 0
      }} transition={{
        duration: 0.3
      }} data-id="element-175">
          <ChevronDownIcon size={20} className="group-hover:translate-y-0.5 transition-transform" data-id="element-176" />
        </motion.div>
      </button>
    </div>;
}